var exports = {
  "h": "trigger__MoXGxK",
  "P": "label__jKRgNX",
};

module.exports = exports;
